/** Short-lived cache so AccountEdit + check-in modal don't duplicate GET /profile/edit. */

let cache = null;
const MAX_AGE_MS = 5 * 60 * 1000;

export function setProfileEditCache(profile, token) {
  if (profile && token) {
    cache = { profile, token, at: Date.now() };
  }
}

export function peekProfileEditCache() {
  if (!cache || Date.now() - cache.at > MAX_AGE_MS) {
    return null;
  }
  return { profile: cache.profile, token: cache.token };
}

export function clearProfileEditCache() {
  cache = null;
}
